import { render, staticRenderFns } from "./AutoForward.vue?vue&type=template&id=e6030388"
import script from "./AutoForward.vue?vue&type=script&lang=js"
export * from "./AutoForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports